<template>
  <footer class="c-footer">
    <div class="mfs-auto">
      Powered By
      <a target="_blank" href="https://sapns2.com/">SAP NS2</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>
